import React from 'react';
import { RadioGroup, Text } from '@nerdwallet/currency';
import classes from '@nerdwallet/base-styles/classes';
import PropTypes from 'prop-types';

const RadioGroupFields = ({ onChange, value, options, keyValue, label }) => {
  return (
    <div className={classes(['padding-vertical-3', 'max-width-60--wide'])}>
      <div className={classes('margin-bottom-2')}>
        <Text>{label}</Text>
      </div>
      <RadioGroup
        onChange={(e) => onChange(keyValue, e.target.value)}
        value={value}
        options={options}
      />
    </div>
  );
};

RadioGroupFields.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  options: PropTypes.object,
  keyValue: PropTypes.string,
  label: PropTypes.string,
};

RadioGroupFields.defaultProps = {
  options: [],
};

export default RadioGroupFields;
